import {DescriptorType, FilterItem} from "../consts/khw-consts";


export const renderInitialFiltersWithSource = (sourceName: string[]): FilterItem[] => {
    return [
        {fullName: DescriptorType.PERSONAL, isSelected: false, type: 'descriptor_type'},
        {fullName: DescriptorType.CORPORATE, isSelected: false, type: 'descriptor_type'},
        {fullName: DescriptorType.EVENT, isSelected: false, type: 'descriptor_type'},
        {fullName: DescriptorType.CHRONOLOGICAL, isSelected: false, type: 'descriptor_type'},
        {fullName: DescriptorType.GEOGRAPHIC, isSelected: false, type: 'descriptor_type'},
        {fullName: DescriptorType.SUBJECT, isSelected: false, type: 'descriptor_type'},
        {fullName: DescriptorType.GENRE, isSelected: false, type: 'descriptor_type'},
        {fullName: DescriptorType.AUTHOR_TITLE, isSelected: false, type: 'descriptor_type'},
        {fullName: DescriptorType.UNIFORM_TITLE, isSelected: false, type: 'descriptor_type'},
        {fullName: 'mesh_main_heading', isSelected: false, type: 'descriptor_type'},
        {fullName: 'mesh_geographics', isSelected: false, type: 'descriptor_type'},
        {fullName: 'DBN', label: 'DBN files', isSelected: sourceName.includes('DBN'), type: 'source'},
        {fullName: 'MESH', label: 'MeSH files', isSelected: sourceName.includes('MESH'), type: 'source'},
        {fullName: 'creation_date', type: 'date', value: null, isSelected: false},
        {fullName: 'modification_date', type: 'date', value: null, isSelected: false}
    ]
}